/**
 * WhatsApp Integration Helper
 * Formats messages and handles WhatsApp deep linking
 */

const WHATSAPP_NUMBER = '917287809847'; // F&H Audio Solutions contact

class WhatsAppHelper {
  /**
   * Format package details for WhatsApp message
   */
  static formatPackageMessage(recommendation, userParams) {
    const speakers = recommendation.equipment.speakers
      .map(s => `  • ${s.quantity}× ${s.brand} ${s.model}`)
      .join('\n');
    
    const accessories = recommendation.equipment.accessories
      .map(a => `  • ${a.quantity}× ${a.description}`)
      .join('\n');

    const message = `Hi F&H Audio Solutions! 👋

I used your *System Planner* and I'm interested in this package:

*📦 Package:* ${recommendation.name}
*💰 Investment:* ₹${this.formatPrice(recommendation.pricing.total)}

*🏛️ My Venue Details:*
• Type: ${this.formatVenueType(userParams.venueType)}
• Dimensions: ${userParams.length}ft × ${userParams.width}ft × ${userParams.height}ft
• Total Area: ${userParams.length * userParams.width} sq.ft
• Capacity: ${userParams.capacity} people
• Usage: ${userParams.usage.join(', ')}

*🔊 Recommended Equipment:*
*Speakers:*
${speakers}

*Mixer:* ${recommendation.equipment.mixer.brand} ${recommendation.equipment.mixer.model}

${recommendation.equipment.amplifiers.length > 0 ? `*Amplifiers:*\n${recommendation.equipment.amplifiers.map(a => `  • ${a.quantity}× ${a.brand} ${a.model}`).join('\n')}\n` : ''}
*Accessories:*
${accessories}

*💡 Why This System:*
${recommendation.whyRecommended}

I would like to:
✓ Schedule a site visit
✓ Get a detailed quotation
✓ Discuss customization options

Please contact me to proceed further.

Thank you! 🙏`;

    return message;
  }

  /**
   * Format consultation request message
   */
  static formatConsultationMessage(userParams) {
    const message = `Hi F&H Audio Solutions! 👋

I need expert consultation for my venue sound system.

*🏛️ Venue Details:*
• Type: ${this.formatVenueType(userParams.venueType)}
• Dimensions: ${userParams.length}ft × ${userParams.width}ft × ${userParams.height}ft
• Area: ${userParams.length * userParams.width} sq.ft
• Capacity: ${userParams.capacity} people
• Usage: ${userParams.usage.join(', ')}
• Budget: ${this.formatBudget(userParams.budget)}

Please help me design the perfect sound system for my needs.

Looking forward to your guidance! 🙏`;

    return message;
  }

  /**
   * Format general inquiry message
   */
  static formatGeneralInquiry() {
    return `Hi F&H Audio Solutions! 👋

I'm interested in your PA System Design services. Could you please share more information?

Thank you!`;
  }

  /**
   * Open WhatsApp with pre-filled message
   */
  static sendMessage(message) {
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
    
    // Open in new tab
    window.open(whatsappUrl, '_blank');
  }

  /**
   * Send package booking request
   */
  static bookPackage(recommendation, userParams) {
    const message = this.formatPackageMessage(recommendation, userParams);
    this.sendMessage(message);
  }

  /**
   * Send consultation request
   */
  static requestConsultation(userParams) {
    const message = this.formatConsultationMessage(userParams);
    this.sendMessage(message);
  }

  /**
   * Send general inquiry
   */
  static sendInquiry() {
    const message = this.formatGeneralInquiry();
    this.sendMessage(message);
  }

  /**
   * Helper: Format price in lakhs
   */
  static formatPrice(amount) {
    if (amount >= 100000) {
      return `${(amount / 100000).toFixed(2)} Lakhs`;
    }
    return `${(amount / 1000).toFixed(0)}K`;
  }

  /**
   * Helper: Format venue type
   */
  static formatVenueType(type) {
    const types = {
      'church': 'Church / Place of Worship',
      'auditorium': 'Auditorium / Theatre',
      'function_hall': 'Function Hall / Banquet',
      'corporate': 'Corporate / Meeting Room',
      'open_ground': 'Open Ground / Outdoor Event'
    };
    return types[type] || type;
  }

  /**
   * Helper: Format budget category
   */
  static formatBudget(budget) {
    const budgets = {
      'economy': 'Economy (Budget-friendly)',
      'mid-range': 'Mid-range (Balanced)',
      'premium': 'Premium (High-end)'
    };
    return budgets[budget] || budget;
  }
}

export default WhatsAppHelper;
